import React from "react";
import BlogTwentyNine from "../component/BlogTwentyNine";

function BlogTwentyNineContainer() {
  return <BlogTwentyNine />;
}
export default BlogTwentyNineContainer;
